import { render, staticRenderFns } from "./WomenEntrepreneursPage.vue?vue&type=template&id=475f2150&scoped=true"
import script from "./WomenEntrepreneursPage.vue?vue&type=script&lang=js"
export * from "./WomenEntrepreneursPage.vue?vue&type=script&lang=js"
import style0 from "./WomenEntrepreneursPage.vue?vue&type=style&index=0&id=475f2150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475f2150",
  null
  
)

export default component.exports